import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { Message } from 'semantic-ui-react';
import { pickBy, includes, get } from 'lodash';

import { TitledCard } from 'Components/';
import { Filter, Main } from 'Containers/';
import { LoadingPage } from 'Components/loading/LoadingPage';
import { ZERO_NEGATIVE_BALANCE_FORM_NAME } from 'Common/FormEnum';
import { getId as getUserId } from 'Common/Security/state/selectors';
import { setYesNoDialogProps } from 'Components/dialogs/state/actions';
import { setNotificationDialog } from 'Components/dialogs/state/actions';
import { NOTIFICATION_DIALOG_MESSAGES } from 'Common/Constants';
import { createToast, toastType, errorToast } from 'Common/ToastHelper';
import { StatusEnum } from 'Common/Constants/Enumeration/StatusEnum';

import { ZeroNegativeBalanceForm } from './components/ZeroNegativeBalanceForm';
import {
  setSaveSuccessful,
  clearError,
  writeBalanceToZero,
  getNegativeAccounts,
  setNoDataDialog,
  setDialog,
} from '../state/zeroNegativeBalance/actions';
import * as Selectors from '../state/zeroNegativeBalance/selectors';

class ZeroNegativeBalanceContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      model: null,
      initialValues: this.createInitialValues(),
      statusCheckboxes: this.statusCheckboxes(),
    };
  }

  getMainProps = () => {
    const { loading } = this.props;
    return {
      toolbox: {
        formName: ZERO_NEGATIVE_BALANCE_FORM_NAME,
        saveButtonProps: {
          content: 'Process',
          disabled: loading,
          loading: loading,
        },
        shown: true,
      },
    };
  };

  componentDidUpdate(prevProps) {
    const {
      saveSuccessful,
      showDialog,
      showNoDataDialog,
      setSaveSuccessful,
      setYesNoDialogProps,
      setNotificationDialog,
      setNoDataDialog,
      clearError,
      negativeAccounts,
    } = this.props;

    if (prevProps.showDialog !== showDialog) {
      setYesNoDialogProps({
        title: 'Zero Out Negative Balances',
        showDialog: showDialog,
        question: this.createMessage(),
        yesCallback: () => this.handleDialogSubmit(true),
        noCallback: () => this.handleDialogSubmit(false),
      });
    }

    if (prevProps.showNoDataDialog !== showNoDataDialog) {
      setNotificationDialog(
        NOTIFICATION_DIALOG_MESSAGES.ZERO_NEGATIVE_BALANVE_NO_DATA_MESSAGE
      );
      setNoDataDialog(false);
    }

    if (
      prevProps.saveSuccessful !== saveSuccessful &&
      saveSuccessful === true
    ) {
      createToast(
        toastType.success,
        'Success',
        this.createSuccessWording(negativeAccounts)
      );
      setSaveSuccessful(false);
    }

    if (errorToast(this.props, prevProps, 'error')) {
      clearError();
    }
  }

  createSuccessWording = quantity => {
    if (quantity > 1) {
      return `${quantity} Accounts with negative balances were set to zero`;
    } else if (quantity === 1) {
      return '1 Account with a negative balance was set to zero. ';
    }
  };

  handleDialogSubmit = yesNo => {
    const { writeBalanceToZero, setDialog } = this.props;
    if (yesNo) {
      writeBalanceToZero(this.state.model);
    }
    setDialog(false);
  };

  createMessage = () => {
    const { negativeAccounts } = this.props;
    const message = (
      <div>
        <p>
          {`${negativeAccounts} ${this.createWording(negativeAccounts)}`}
          Each account balance will be set to zero and a Payment Transaction
          will be added to offset the difference.
        </p>
        <br />
        <br />
        <br />
        <p>Do you still wish to continue?</p>
      </div>
    );

    return message;
  };

  createWording = quantity => {
    if (quantity > 1) {
      return 'Accounts were found with negative balances. ';
    } else if (quantity === 1) {
      return 'Account was found with a negative balance. ';
    }
  };

  handleNoDataDialog = () => {
    this.props.setNoDataDialog(false);
  };

  statusCheckboxes = () => {
    return Object.values(StatusEnum)
      .filter(f => f !== StatusEnum.Deleted)
      .map(value => ({
        name: `Status${value}`,
        label: value,
        checked: true,
      }));
  };

  createInitialValues = () => {
    let initialValues = {};

    this.statusCheckboxes().forEach(x => {
      initialValues[x.name] = {
        value: true,
      };
    });

    return initialValues;
  };

  createModel = values => {
    let model = {};
    model = {
      Status2: values.includes('2') ? true : false,
      Status3: values.includes('3') ? true : false,
      Status4: values.includes('4') ? true : false,
      Status5: values.includes('5') ? true : false,
      Status6: values.includes('6') ? true : false,
      Status7: values.includes('7') ? true : false,
      Status8: values.includes('8') ? true : false,
      Status9: values.includes('9') ? true : false,
    };
    return model;
  };

  validateModel = model => {
    return !Object.values(model).every(x => x === false);
  };

  getStatuses = formValues => {
    const selectedStatuses = pickBy(
      formValues,
      (value, key) => includes(key, 'Status') && value
    );

    return Object.keys(selectedStatuses).map(x => {
      return x.match(/\d+/)[0];
    });
  };

  updateCheckBoxes = model => {
    return Object.values(StatusEnum)
      .filter(f => f !== StatusEnum.Deleted)
      .map(value => ({
        name: `Status${value}`,
        label: value,
        checked: get(model, `Status${value}`),
      }));
  };

  handleSubmit = formValues => {
    const model = this.createModel(this.getStatuses(formValues));
    const statuses = this.updateCheckBoxes(model);

    this.setState({
      initialValues: formValues,
      statusCheckboxes: statuses,
    });

    const isValid = this.validateModel(model);

    if (isValid) {
      const { userId, getNegativeAccounts } = this.props;
      model.UserId = userId;

      getNegativeAccounts(model);
      this.setState({ model });
    } else {
      createToast(
        toastType.error,
        'Error',
        'At least one status must be checked.'
      );
    }
  };

  render() {
    const { loading, statusOptions } = this.props;
    const { initialValues, statusCheckboxes } = this.state;
    if (loading) {
      return <LoadingPage message={'Loading'} />;
    }
    return (
      <Fragment>
        <Filter title={'Zero Negative Balance Utility'} />
        <Main {...this.getMainProps()}>
          <TitledCard title={'Zero Out Negative Balances'}>
            <Message negative>
              <Message.Content>
                This utility will update all accounts that have a negative
                balance. Each account will recieve a payment record in
                Transaction History to offset the negative balance.
              </Message.Content>
            </Message>
            <ZeroNegativeBalanceForm
              initialValues={initialValues}
              onSubmit={this.handleSubmit}
              statusOptions={statusOptions}
              statusCheckboxes={statusCheckboxes}
            />
          </TitledCard>
        </Main>
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    userId: getUserId(state),
    negativeAccounts: Selectors.getNegativesAccounts(state),
    saveSuccessful: Selectors.SaveSuccessful(state),
    loading: Selectors.getLoading(state),
    error: Selectors.getError(state),
    showNoDataDialog: Selectors.getShowNoDataDialog(state),
    showDialog: Selectors.getShowDialog(state),
  };
};

const mapDispatchToProps = {
  clearError,
  setSaveSuccessful,
  writeBalanceToZero,
  getNegativeAccounts,
  setDialog,
  setNoDataDialog,
  setNotificationDialog,
  setYesNoDialogProps,
};

export const ZeroNegativeBalance = withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ZeroNegativeBalanceContainer)
);



// WEBPACK FOOTER //
// ./src/pages/utilities/zeroNegativeBalance/ZeroNegativeBalance.js